import { store } from "../../store";
import { controlLoading } from "../../slices/app.slice";
import * as service from "../service";

export type PasswordResetAccountType = "student" | "business";

export const requestPasswordResetCodeAPI = async (
  email: string,
  accountType: PasswordResetAccountType = "student",
) => {
  if (!email || !email.trim()) {
    return { result: "Email is required", status: 2 };
  }
  try {
    return await service.call(
      "POST",
      "api/user/passwordReset/requestCode",
      { email: email.trim(), accountType },
      { timeout: 20000 },
    );
  } catch (err) {
    store.dispatch(controlLoading({ showLoading: false }));
    console.error(`requestPasswordResetCodeAPI ${err}`);
  }
};

export const verifyPasswordResetCodeAPI = async (
  email: string,
  code: string,
  accountType: PasswordResetAccountType = "student",
) => {
  if (!email || !email.trim() || !code || !code.trim()) {
    return { result: "Email and verification code are required", status: 2 };
  }
  try {
    return await service.call(
      "POST",
      "api/user/passwordReset/verifyCode",
      { email: email.trim(), code: code.trim(), accountType },
      { timeout: 20000 },
    );
  } catch (err) {
    store.dispatch(controlLoading({ showLoading: false }));
    console.error(`verifyPasswordResetCodeAPI ${err}`);
  }
};

export const resetPasswordAPI = async (
  email: string,
  password: string,
  accountType: PasswordResetAccountType = "student",
) => {
  if (!email || !email.trim() || !password) {
    return { result: "Email and password are required", status: 2 };
  }
  try {
    return await service.call(
      "POST",
      "api/user/passwordReset/reset",
      { email: email.trim(), password, accountType },
      { timeout: 20000 },
    );
  } catch (err) {
    store.dispatch(controlLoading({ showLoading: false }));
    console.error(`resetPasswordAPI ${err}`);
  }
};
